
import { HttpClient, HttpHeaders } from "@angular/common/http"
import { Injectable } from "@angular/core";
import { map } from "rxjs/operators"
import { Observable, ObservableLike } from "rxjs";
import { Device } from "./interfaces/deviceInfo";
import 'devextreme/data/odata/store';
//import * as AspNetData from 'devextreme-aspnet-data-nojquery';
import { AttLog, AttLogChart } from "./interfaces/attLog";
import { environment } from "../../environments/environment";
import { PushLicense } from "./interfaces/pushLicense";
import { UserInfo, UserInfoSynchronize, UserInfoGeneralSynchronize, IUserMSGModel, PersonBioTemplate } from "./interfaces/userInfo";
import { UserData } from "./interfaces/userData";
  
export class State {
    ID: number;
    Name: string;
  }
 
export class Command {
    id: string;
    name: string;
    icon?: string;
    command?: string;
    disabled?: boolean;
    items?: Command[];
}
export class AttLogCommand{
    
    endTime: Date;
    startTime:   Date
    deviceSN:  string;
}
 
export class PopulationDevices
{
    arg: string;
    val: number;
} 

@Injectable()
export class DataService
{
    url: string;
    public resultAttLog:string = "";
    public ressultCheck: string = ""; 
    private token: string = "";
    private tokenExpiration: Date;
    private commands: Command[] = 
    [
        {
        id: "1",
        name: "Dispositivo",
        items: 
        [
            {
            id: "1_1",
            name: "Zona Horaria",
            command :"timeZone"
            },
            {
                id: "1_2",
                name: "Información del dispositivo",
                command :"devInfo"
                // icon: "images/products/2.png",
            },
            {
                id: "1_3",
                name: "Traer toda la información",
                command :"check"
                // icon: "images/products/2.png",
            },
            {
                id: "1_4",
                name: "Actualizar Reporte de Usuarios",
                command :"checkUsers"
                // icon: "images/products/2.png",
            }            
        ]
        },
        {
            id: "2",
            name: "Registros",
            items: 
            [
                {
                    id: "2_1",
                    name: "Traer registros",
                    command :"attlog"
                    // icon: "images/products/1.png"
                },
                {
                    id: "2_2",
                    name: "Borrar registros",
                    command :"delLog"
                    // icon: "images/products/2.png",
                }, 
            ]
            }
    ];

    private userCommands: Command[] = 
    [
        {
        id: "1",
        name: "Usuarios",
        items: 
        [
            {
                id: "1_1",
                name: "Transferir Usuarios",
                command :"TransfUsuario"
            },                        
            {
                id: "1_2",
                name: "Borrar Biometrías",
                command :"BorraBiometria"
                // icon: "images/products/2.png",
            },
            {
                id: "1_3",
                name: "Borrar Usuarios",
                command :"BorraUsuario"
                // icon: "images/products/2.png",
            },
            {
                id: "1_4",
                name: "Cambiar Contraseña",
                command :"ResetPassword"
                // icon: "images/products/2.png",
            },
            {
                id: "1_5",
                name: "Obtener Biometrias",
                command :"TraeBiometria"
            }            
        ]
        },
        {
            id: "2",
            name: "Mensajes",
            items: 
            [
                {
                id: "2_1",
                name: "Mensajes",
                command :"mensaje"
                // icon: "images/products/1.png"
                },
                {
                id: "2_2",
                name: "Mensaje de Usuario",
                command :"mensajeUsuario"
                // icon: "images/products/1.png"
                }  
            ]
            }
    ];

    public devices: Device[] = [];
    public personBioTemplates: PersonBioTemplate[] = [];
    public attLog :any[] =[];//attlogviewModel
    public attlogChart : AttLogChart[] =[]
    public updateDevice : Device;
    public insertDevice :Device;
    public pushLicense: PushLicense;
    public userInfo: UserInfo[];
    public updateUser : UserInfo;
    public sendUserInfoSynchronize : boolean;
    
    constructor(private http: HttpClient)
    {
        this.token = localStorage.getItem('auth_token');
        this.tokenExpiration = new Date(localStorage.getItem('auth_token_expiration'));
        console.log(this.token);
        console.log(this.tokenExpiration);
    };
   

 
    //Funcion para agrupar  un arreglo
    public groupBy = function(xs, key) 
    {
        return xs.reduce(function(rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x);
        return rv;
        }, {});
    };
     
    public get loginRequired(): boolean 
    {
        return this.token == null || this.token.length == 0 || this.tokenExpiration < new Date();
    }
    public logOut() 
    {
        this.token= undefined;
        this.tokenExpiration = undefined;
        localStorage.removeItem("auth_token");
        localStorage.removeItem('auth_token_expiration');
        console.log(localStorage.getItem('auth_token'));
    }
    public  getVersionApi(): Observable<string>
    {
        return this.http.get(environment.URLWebservice+"/api/PushInfo/",
        {
            responseType: 'text'
        })
        .pipe(map((response:string)=>
            { 
                return response;
            }));
    }
    public login(creds): Observable<boolean>
    { 
        console.log(environment.URLWebservice+"/account/createtoken");
        console.log(creds);
        return this.http.post(  environment.URLWebservice+"/account/createtoken", creds,
        {
            headers: new HttpHeaders() 
            .set('Content-Type','application/json')
            
        })
            .pipe(
                map((response: any) => {
                    let tokenInfo = response;
                    this.token = tokenInfo.token;
                    localStorage.setItem('auth_token', tokenInfo.token);
                    localStorage.setItem('auth_token_expiration',tokenInfo.expiration);
                    this.tokenExpiration = tokenInfo.expiration;

                    console.log(this.token);
                    return true;
                }));
    }
    public loadDevices(): Observable<boolean>{
        return this.http.get( environment.URLWebservice+'/api/device/GetAllDevices',
    {
        headers: new HttpHeaders() 
        .set('Authorization', 'Bearer '+this.token),
    })
            .pipe(
                map((data: any[])=>
                {
                    this.devices = data;
                    return true;
                })
            );
    }
    public loadBioTemplates(userPIN: string): Observable<boolean>{
        return this.http.get( environment.URLWebservice+'/api/UserDevice/GetBioTemplates?userPIN=' + userPIN,
    {
        headers: new HttpHeaders() 
        .set('Authorization', 'Bearer '+this.token),
    })
            .pipe(
                map((data: any[])=>
                {
                    this.personBioTemplates = data;
                    return true;
                })
            );
    }
    public commandSynchronizeUserInfoCommand(data : UserInfoGeneralSynchronize) 
        :Observable<boolean>
    {
        return this.http.post( environment.URLWebservice+'/api/UserDevice/UpdateUserInfo/',
        data,
    {
        headers: new HttpHeaders() 
        .set('Authorization', 'Bearer '+this.token),
    })
        .pipe(
            map((data: boolean)=>
            {
                //el dato que regresa es un entero 
                console.log("UpdateUserInfo result: "+ data );
                return true;
            })
        );
    }
    public commandSynchronizeFingerpringCommand(data: UserInfoSynchronize)
    : Observable<boolean>
    {
        return this.http.post( environment.URLWebservice+'/api/UserDevice/UpdateFingerprintTemplate/',
            data,
        {
            headers: new HttpHeaders() 
            .set('Authorization', 'Bearer '+this.token),
        })
            .pipe(
                map((data: boolean)=>
                {
                    this.sendUserInfoSynchronize = data;
                    return true;
                })
            );
    }
    public commandResetPassword(data: IUserMSGModel)
    : Observable<boolean>
    {
        return this.http.post( environment.URLWebservice+'/api/UserDevice/UpdateUserPassword/',
            data,
        {
            headers: new HttpHeaders() 
            .set('Authorization', 'Bearer '+this.token),
        })
            .pipe(
                map((data: boolean)=>
                {
                    this.sendUserInfoSynchronize = data;
                    return true;
                })
            );
    }
    public SendShortMSG(data : IUserMSGModel) 
        :Observable<boolean>
    {
        return this.http.post( environment.URLWebservice+'/api/UserDevice/SendShortMSG/',
        data,
    {
        headers: new HttpHeaders() 
        .set('Authorization', 'Bearer '+this.token),
    })
        .pipe(
            map((data: boolean)=>
            {
                //el dato que regresa es un entero 
                console.log("SendShortMSG result: "+ data );
                return true;
            })
        );
    }
    public GetUserBio(data: UserInfoSynchronize)
    : Observable<boolean>
    {
        return this.http.post( environment.URLWebservice+'/api/UserDevice/GetUserBio/',
            data,
        {
            headers: new HttpHeaders() 
            .set('Authorization', 'Bearer '+this.token),
        })
            .pipe(
                map((data: boolean)=>
                {
                    this.sendUserInfoSynchronize = data;
                    return true;
                })
            );
    }         
    public delUserBio(data: UserInfoSynchronize)
    : Observable<boolean>
    {
        return this.http.post( environment.URLWebservice+'/api/UserDevice/DeleteUserBio/',
            data,
        {
            headers: new HttpHeaders() 
            .set('Authorization', 'Bearer '+this.token),
        })
            .pipe(
                map((data: boolean)=>
                {
                    this.sendUserInfoSynchronize = data;
                    return true;
                })
            );
    } 
    public delUserAD(data: UserInfoSynchronize)
    : Observable<boolean>
    {
        return this.http.post( environment.URLWebservice+'/api/UserDevice/DeleteUserAD/',
            data,
        {
            headers: new HttpHeaders() 
            .set('Authorization', 'Bearer '+this.token),
        })
            .pipe(
                map((data: boolean)=>
                {
                    this.sendUserInfoSynchronize = data;
                    return true;
                })
            );
    }           
    public GetUserData() : Observable<UserData>
    {
        return this.http.get(environment.URLWebservice+
            '/Account/GetDataUser',
            {
                headers: new HttpHeaders()
                .set('Content-Type','application/json')
                    
            })
            .pipe(map((userData:UserData)=>
            { 
                return userData;
            }));
    }
    public changeDataUser(data) : Observable<boolean>
    {
        return this.http.post(environment.URLWebservice+'/Account/changeDataUser',
        data,
        {
            headers: new HttpHeaders()
            .set('Content-Type','application/json')
            .set('Authorization','Bearer '+ this.token),
        })
        .pipe(map((data:boolean)=>
        {
            return true;
        }));
    }
    public confirmEmail(data) : Observable<boolean>
    {
        return this.http.post(environment.URLWebservice+'/Account/RecoveryPassword',
            data,
            {
                headers: new HttpHeaders()
                .set('Content-Type','application/json')
                .set('Authorization','Bearer '+ this.token),
            })
            .pipe(map((data:boolean)=>
            {
                return true;
            }));
    }

    public getConfirmEmail(user) : Observable<boolean>
    {
        return this.http.get(environment.URLWebservice +
            '/Account/RecoveryPassword?user='+user,
            {
                headers: new HttpHeaders()
                .set('Content-Type','application/json')
                .set('Authorization','Bearer '+ this.token),
            })
            .pipe(map((data:boolean)=>
            {
                return true;
            }));
    }
    public getUsersInfo()
    {
        return this.http.get(environment.URLWebservice+'/api/UserDevice/GetUserInfo',
        {
            headers: new HttpHeaders()
            .set('Authorization','Bearer'+this.token),
        }).pipe(map((data: UserInfo[])=>
                {
                    console.log(data);
                    this.userInfo = data;
                    return true;   
                }));
    }

    public getPushLicense()
    {
        return this.http.get( environment.URLWebservice+ '/api/Device/GetLicense/',
        {
            headers: new HttpHeaders() 
            .set('Authorization', 'Bearer '+this.token),
        })
                    .pipe(
                        map((data: PushLicense)=>
                        {
                            console.log(data);
                            this.pushLicense = data;
                            return true;
                        }));
    }
    public loadAttLogs(startDate: string,endDate: string): Observable<boolean>
    {

        return this.http.get( environment.URLWebservice+ '/api/device/GetAttLogs?startDate='+startDate+'&endDate='+endDate,
    {
        headers: new HttpHeaders() 
        .set('Authorization', 'Bearer '+this.token),
    })
                .pipe(
                    map((data: any[])=>
                    {
                        console.log(data);
                        this.attLog = data;
                        return true;
                    }));
    }
    public loadGetAttLogsChart(startDate: string,endDate: string): Observable<boolean>
    {

        return this.http.get( environment.URLWebservice+ '/api/device/GetAttLogsChart?startDate='+startDate+'&endDate='+endDate,
            {
                headers: new HttpHeaders() 
                .set('Authorization', 'Bearer '+this.token),
            })
                .pipe(
                    map((data: AttLogChart[])=>
                    {
                        console.log(data);
                        this.attlogChart = data;
                        return true;
                    }));
    }
    public updateDeviceBySN(data:Device): Observable<boolean>{
            return this.http.post( environment.URLWebservice+'/api/device/UpdateDevice',data,
            {
                headers: new HttpHeaders() 
                .set('Authorization', 'Bearer '+this.token),
            })
                .pipe(
                    map((data: Device)=>
                    {
                        this.updateDevice = data;
                        return true;
                    })
                );
    } 
    public updateUserInfo(data:UserInfo): Observable<boolean>{
        return this.http.post( environment.URLWebservice+'/api/UserDevice/UpdateUserInfo',data,
        {
            headers: new HttpHeaders() 
            .set('Authorization', 'Bearer '+this.token),
        })
            .pipe(
                map((data: UserInfo)=>
                {
                    this.updateUser = data;
                    return true;
                })
            );
}       
    public queryAttLog(data:AttLogCommand): Observable<boolean>
    {
         
        return this.http.post( environment.URLWebservice+'/api/DeviceAction/QueryAttLog/' ,data,
        {
            headers: new HttpHeaders() 
                        .set('Authorization', 'Bearer '+this.token),
           responseType: 'text'
        })
            .pipe(
                map((data: any)=>
                {
                    //retorna un short
                    this.resultAttLog = data;
                    return true;//short
                })
            );
    }

    public delAttLog(data:AttLogCommand): Observable<boolean>
    {
         
        return this.http.post( environment.URLWebservice+'/api/DeviceAction/DeleteAttlogs/' ,data,
        {
            headers: new HttpHeaders() 
                        .set('Authorization', 'Bearer '+this.token),
           responseType: 'text'
        })
            .pipe(
                map((data: any)=>
                {
                    //retorna un short
                    this.resultAttLog = data;
                    return true;//short
                })
            );
    }

    public queryTimeZone(deviceSN:string,tz:number): Observable<boolean>
    {
         
        return this.http.get( environment.URLWebservice+'/api/DeviceAction/ChangeTimeZone/?deviceSN='+deviceSN+"&tz="+tz ,
        {
            headers: new HttpHeaders() 
                        .set('Authorization', 'Bearer '+this.token),
           responseType: 'text'
        })
            .pipe(
                map((data: any)=>
                {
                    //retorna un short
                    console.log("Result QueryTimeZone: "+ data);
                    return true;//short
                })
            );
    }

    public queryCheck(data:string): Observable<boolean>
    {
         
        return this.http.get( environment.URLWebservice+'/api/DeviceAction/CheckDeviceData/?deviceSN='+data,
        {
            headers: new HttpHeaders() 
                        .set('Authorization', 'Bearer '+this.token),
            responseType: 'text'
        }).pipe(
                map((data: any)=>
                {
                    //retorna un short
                    this.resultAttLog = data;
                    return true;//short
                })
            );
    } 

    public queryCheckUsers(data:string): Observable<boolean>
    {
        return this.http.get( environment.URLWebservice+'/api/DeviceAction/CheckDeviceUsers/?deviceSN='+data,
        {
            headers: new HttpHeaders() .set('Authorization', 'Bearer '+this.token),
            responseType: 'text'
        }).pipe(
                map((data: any)=>
                {
                    //retorna un short
                    this.resultAttLog = data;
                    return true;//short
                })
            );
    } 

    public queryDevInfo(data:string): Observable<boolean>
    {
         
        return this.http.get( environment.URLWebservice+'/api/DeviceAction/QueryDeviceInfo/?deviceSN='+data,
        {
            headers: new HttpHeaders() 
                        .set('Authorization', 'Bearer '+this.token),
            responseType: 'text'
        }).pipe(
                map((data: any)=>
                {
                    //retorna un short
                    this.resultAttLog = data;
                    return true;//short
                })
            );
    }

    addDevice(data:Device): Observable<boolean>
    {
        return this.http.post( environment.URLWebservice+'/api/device/AddDevice',data,
        {
            headers: new HttpHeaders() 
            .set('Authorization', 'Bearer '+this.token)
        })
            .pipe(
                map((data: Device)=>
                {
                    this.insertDevice = data;
                    return true;
                })
            );
    }
     
    public get  getCommands (): Command[] {
        return this.commands;
    }
    public get  getUserCommands (): Command[] {
        return this.userCommands;
    }
}